import 'react-datepicker/dist/react-datepicker.css';
import { Control, FieldError, FieldValues } from 'react-hook-form';

import { Size } from 'coreOld/enums';

import DateInputWithControllerView from './DateInputWithControllerView';
import DateInputView from './DateInputView';

interface IProps {
  name?: string;
  control?: Control<FieldValues, object>;
  required?: boolean;
  label?: string;
  placeholder?: string;
  timeInputLabel?: string;
  startDate?: Date;
  endDate?: Date;
  minDate?: Date;
  selected?: Date;
  selectsEnd?: boolean;
  selectsStart?: boolean;
  showTimeInput?: boolean;
  size?: Size;
  showBorder?: boolean;
  hasBorder?: boolean;
  selectsRange?: boolean;
  monthsShown?: number;
  inline?: boolean;
  onChange?;
  dateFormat?: string;
  error?: FieldError;
  showFieldError?: boolean;
  disabled?: boolean;
  editable?: boolean;
  isClearable?: boolean;
  showMonthDropdown?: boolean;
  showYearDropdown?: boolean;
}

const DATE_FORMAT = 'MM/dd/yyyy h:mm';

const DateInput = (props: IProps) => {
  const { showTimeInput, timeInputLabel, dateFormat, disabled, editable } = props;

  const isDisabledState = disabled && !editable;

  const timeProps = props.showTimeInput
    ? {
        timeInputLabel,
        dateFormat: dateFormat || DATE_FORMAT,
        showTimeInput,
      }
    : {};

  if (props.control) {
    return <DateInputWithControllerView {...{ ...props, ...timeProps, isDisabledState }} />;
  }

  return <DateInputView {...{ ...props, ...timeProps }} />;
};

export default DateInput;
